import React from "react";
import { connect } from "react-redux";
import { Flex } from "/app/src/component";
import Jibber from "/app/src/jibber";
import QuickResponseModel from "/app/src/model/QuickResponse/model";
import ItemEditorView from "./Item/ItemEditorView";
import style from "./style.css";

class Item extends Jibber {
  constructor(props) {
    super(props);
    this.useState({
      screen: "normal",
    });

    this.createInDB = this.createInDB.bind(this);
  }

  _toEditor() {
    this.setState({ screen: "edit" });
  }

  createInDB(title, body) {
    this.props.dispatch(QuickResponseModel.create(title, body));
    this.setState({ screen: "normal", title: "", quickResponse: "" });
  }

  render() {
    switch (this.state.screen) {
      case "create":
        return (
          <ItemEditorView
            title=""
            body=""
            toNormal={() => {
              this.setScreen("normal");
            }}
            saveToDB={this.createInDB}
          />
        );
      case "normal":
      default:
        return (
          <Flex
            onClick={() => {
              this.setScreen("create");
            }}
            className={style.FAQAdd}
            backgroundColor="darkwhite"
            color="black"
            height="40px"
            center
          >
            + Lägg till Snabbsvar
          </Flex>
        );
    }
  }
}

export default connect()(Item);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ChatSettings/QuickResponse/AddNewQuickResponse.js